import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lifedi-icon-home',
  templateUrl: './icon-home.component.html',
  styleUrls: ['./icon-home.component.scss']
})
export class IconHomeComponent implements OnInit {
  @Input() id: string;
  @Input() title: string;
  @Input() link: string;
  @Input() imageUrl: string;
  constructor() { }

  ngOnInit(): void {
  }

}
